module.exports = __webpack_public_path__ + "static/media/03-Knightsbridge.3e834461.mp4";